import { Component, OnInit, inject, signal } from '@angular/core';
import { BuildService } from '../../services/build.service';

@Component({
  selector: 'pil-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  private readonly buildService = inject(BuildService);

  readonly year = new Date().getFullYear();

  /** The deployed backend version, shown as a build stamp. Stays null when it cannot be read. */
  readonly version = signal<string | null>(null);

  ngOnInit(): void {
    this.buildService.version().subscribe({
      next: version => this.version.set(version),
      error: () => {},
    });
  }
}
